import { Small, Box } from "orcs-design-system";
import PropTypes from "prop-types";
import React, { useCallback, useMemo } from "react";
import {
  MasonryBackground,
  MasonryCardButton,
  MasonryCardContainer,
} from "src/components/GenericMasonry/GenericMasonry.styled";
import { getTextColorSync } from "src/util/getTextContrastColor";

const DefaultBackgroundCard = ({ item, isSelected, onSelectItem }) => {
  const hasItem = !!item;
  const width = item?.width;
  const height = item?.height;
  const color = item?.color;

  const cardHeight = useMemo(() => {
    if (!hasItem || !width || !height || width <= 0 || height <= 0) {
      return 100;
    }
    const ratio = width / height;
    return 190 / ratio;
  }, [hasItem, width, height]);

  const handleClick = useCallback(() => {
    if (hasItem) {
      onSelectItem?.(item);
    }
  }, [hasItem, item, onSelectItem]);

  if (!hasItem) {
    return null;
  }

  return (
    <MasonryCardContainer
      width={190}
      height={cardHeight}
      color={color}
      isSelected={isSelected}
      isSelectable
      data-testid="cp-default-bg-card-container"
    >
      <MasonryCardButton
        type="button"
        aria-pressed={isSelected}
        onClick={handleClick}
        data-testid="cp-default-bg-card-btn"
      >
        <MasonryBackground color={color} style={{ position: "relative" }}>
          <Box
            position="absolute"
            bottom={0}
            right={3}
            p="xs"
            textAlign="right"
            maxWidth="100%"
          >
            <Small color={getTextColorSync(color)} fontSize="1.1rem">
              Default
            </Small>
          </Box>
        </MasonryBackground>
      </MasonryCardButton>
    </MasonryCardContainer>
  );
};

DefaultBackgroundCard.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelectItem: PropTypes.func,
};

export default DefaultBackgroundCard;
